import { render, staticRenderFns } from "./MultiplayerMenu.vue?vue&type=template&id=0b351f9c&scoped=true&lang=pug&"
import script from "./MultiplayerMenu.vue?vue&type=script&lang=js&"
export * from "./MultiplayerMenu.vue?vue&type=script&lang=js&"
import style0 from "./MultiplayerMenu.vue?vue&type=style&index=0&id=0b351f9c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b351f9c",
  null
  
)

export default component.exports